// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"header_wrapper__R1zF_","main":"header_main__n0NRb"};